import './styles.css';

import ReactDOM from 'react-dom/client';
import App from './app';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);

// Enhanced version detection and reload logic
let reloadAttempts = 0;
const maxReloadAttempts = 2;

// Handle Vite preload errors (chunk loading failures)
window.addEventListener('vite:preloadError', (event) => {
  console.log('Vite preload error detected:', event);
  console.warn('New version found. Reloading...');

  if (reloadAttempts < maxReloadAttempts) {
    reloadAttempts++;
    window.location.reload();
  } else {
    console.error('Max reload attempts reached. Please refresh manually.');
  }
});

// Handle chunk loading errors
window.addEventListener('error', (event) => {
  const target = event.target || event.srcElement;

  // Check if it's a script loading error (chunk loading failure)
  if (target && (target as any).tagName === 'SCRIPT') {
    const src = (target as HTMLScriptElement).src;
    if (src && src.includes('/assets/')) {
      console.warn('Script loading failed, likely due to new deployment:', src);

      if (reloadAttempts < maxReloadAttempts) {
        reloadAttempts++;
        window.location.reload();
      }
    }
  }
});
